import  { Component } from 'react';

export class About extends Component {
    //RENDER

    render() {
        return null;
    }
}
